import { Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import type { Currency } from "../../../data/BaseEntity";
import type { Price } from "../../../misc/price";

interface Props {
  readonly price: Price;
  readonly currency: Currency;
  readonly info?: ReactNode;
}

const ProductsTotalPrice: FC<Props> = ({ price, currency, info }) => {
  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      <Typography variant="h6" data-testid="products-total-price">
        {price.toDisplayValue(currency)}
      </Typography>
      {info}
    </span>
  );
};

export default ProductsTotalPrice;
